export default __webpack_public_path__ + "static/media/title.429c0d05.png";